import script from "./welcomeScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./welcomeScreen.vue?vue&type=script&setup=true&lang=js"

import "./welcomeScreen.vue?vue&type=style&index=0&id=45638dec&lang=css"

const __exports__ = script;

export default __exports__